export default __webpack_public_path__ + "static/media/separator.10eae9e9.svg";